import {
  IconChartLineUp,
  IconCirclesThreePlus,
  IconCurrencyCircleDollar,
  IconGift,
  IconHandbagSimple,
  IconList,
  IconUsers,
} from '@vtex/admin-ui'
import { defineMessages } from 'react-intl'
import { CalculatorType, Icon, PROMOTION_TYPE } from 'typings'

export const promotionTypeIcons: Record<CalculatorType, Icon> = {
  regular: IconCurrencyCircleDollar,
  combo: IconHandbagSimple,
  forThePriceOf: IconCirclesThreePlus,
  progressive: IconChartLineUp,
  buyAndWin: IconGift,
  campaign: IconUsers,
  multipleEffects: IconList,
  maxPricePerItem: IconCurrencyCircleDollar,
  tax: IconCurrencyCircleDollar,
}

export const promotionTypeMessages: Record<CalculatorType, { id: string }> =
  defineMessages({
    regular: { id: 'admin/promotions.list.promotion-type.regular' },
    combo: { id: 'admin/promotions.list.promotion-type.combo' },
    forThePriceOf: {
      id: 'admin/promotions.list.promotion-type.more-for-less',
    },
    progressive: { id: 'admin/promotions.list.promotion-type.progressive' },
    buyAndWin: { id: 'admin/promotions.list.promotion-type.buy-and-win' },
    multipleEffects: {
      id: 'admin/promotions.list.promotion-type.multiple-effects',
    },
    campaign: { id: 'admin/promotions.list.promotion-type.campaign' },
    maxPricePerItem: {
      id: 'admin/promotions.list.promotion-type.max-price-per-item',
    },
    tax: {
      id: 'admin/promotions.list.promotion-type.regular',
    },
  })

export const activePromotionTypes = [
  PROMOTION_TYPE.REGULAR,
  PROMOTION_TYPE.BUY_TOGETHER,
  PROMOTION_TYPE.MORE_FOR_LESS,
  PROMOTION_TYPE.PROGRESSIVE,
  PROMOTION_TYPE.BUY_AND_WIN,
  PROMOTION_TYPE.CAMPAIGN,
] as const
